import { render } from "./LoadingScreen.vue?vue&type=template&id=1fa3f636&scoped=true"
import script from "./LoadingScreen.vue?vue&type=script&lang=js"
export * from "./LoadingScreen.vue?vue&type=script&lang=js"

import "./LoadingScreen.vue?vue&type=style&index=0&id=1fa3f636&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1fa3f636"

export default script